/** Optional until the Openings photo-engagement API is deployed. */
export interface PhotoEngagement {
  workPhotoId?: string;
  salonId?: string;
  viewCount?: number;
  openCount?: number;
}

/** Publication IDs, URLs and legacy IDs must never become tracking IDs. */
export function photoEngagementMetadata(photo: PhotoEngagement, salonId?: string): PhotoEngagement {
  return {
    ...(photo.workPhotoId && salonId ? { workPhotoId: photo.workPhotoId, salonId } : {}),
    ...(typeof photo.viewCount === "number" ? { viewCount: photo.viewCount } : {}),
    ...(typeof photo.openCount === "number" ? { openCount: photo.openCount } : {}),
  };
}

export interface PhotoViewsBody {
  salonId: string;
  sessionId: string;
  events: { photoId: string; kind: "impression" | "open" }[];
}
